module.exports = __webpack_public_path__ + "img/adv_ins_3.d83e2f69.png";